import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';    
import { HttpClientModule } from '@angular/common/http'; 
import { ReceptionLoginComponent } from './page/reception-login/reception-login.component';
import { B2cRoutingModule } from './b2c-routing.module'; 
import { SharedModule } from '../../shared/shared.module';
import { CryptoModule } from './crypto.module';

const COMPONENTS = [
  ReceptionLoginComponent ,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    B2cRoutingModule,    
    HttpClientModule, 
    SharedModule,
    CryptoModule
  ],
  providers:[ 
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class B2cModule { }
